import { NSARouterMakerResult } from "namirasoft-account-react";
import { InferencerType } from "namirasoft-inference";
import { Component, ReactNode } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";
import { InferencerTree, InferencerTreeNode } from "./InferencerTree";

export interface InferencerLoaderProps extends NSARouterMakerResult, InferenceRouterProps
{
    inferencer_type: InferencerType | string;
    inferencer_id: string;
    render: (args: { tree: InferencerTreeNode | null; loading: boolean; error: string | null }) => ReactNode;
}

interface InferencerLoaderState
{
    loading: boolean;
    error: string | null;
    tree: InferencerTreeNode | null;
}

export default class InferencerLoader extends Component<InferencerLoaderProps, InferencerLoaderState>
{
    override state: InferencerLoaderState = { loading: false, error: null, tree: null };

    override componentDidMount(): void { this.load(); }

    override componentDidUpdate(prev: InferencerLoaderProps): void
    {
        if (prev.inferencer_type !== this.props.inferencer_type || prev.inferencer_id !== this.props.inferencer_id)
            this.load();
    }

    private async load(): Promise<void>
    {
        let { inferencer_type, inferencer_id } = this.props;
        if (!inferencer_id) { this.setState({ loading: false, error: null, tree: null }); return; }
        this.setState({ loading: true, error: null, tree: null });
        try
        {
            let tree = await InferencerTree.load(this.props.servers.inference, inferencer_type, inferencer_id);
            this.setState({ loading: false, tree });
        }
        catch (e: any)
        {
            console.error(e);
            this.setState({ loading: false, error: e?.message ?? "Failed to load" });
        }
    }

    override render()
    {
        return this.props.render({
            tree: this.state.tree,
            loading: this.state.loading,
            error: this.state.error,
        });
    }
}